module.exports = __webpack_public_path__ + "img/phoneus.32337543.jpg";